// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3RqPE","inputWrap":"Table_inputWrap__3y0QX","col":"Table_col__kW-Ud","bmiTooltip":"Table_bmiTooltip__3svaV"};